import { Button as ButtonComponent } from '@redis-ui/components';
import styled from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: 100%;
  height: 100%;
  color: light-dark(black, white);
`;

export const TextAndButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const Message = styled.div`
  text-align: center;
`;

export const Text = styled.p`
  font-size: 1.8rem;
`;

export const RootContainer = styled.div`
  height: 100vh;
`;

export const Image = styled.img`
  width: 163px;
  height: 98px;
`;

export const Button = styled(ButtonComponent)`
  background-color: light-dark(black, white);
  color: light-dark(white, black);
`;
